var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _g10, _path15, _path16, _path17, _path18, _path19, _path20, _g11, _g12, _path21, _path22, _path23, _path24, _path25, _path26, _path27;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPuzzle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 260,
    height: 233.323,
    viewBox: "0 0 260 233.323",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "illus",
    transform: "translate(-1176.683 -657.527)"
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_3388",
    "data-name": "Groupe 3388",
    transform: "translate(1365.206 722.349)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_11595",
    "data-name": "Trac\\xE9 11595",
    d: "M3316.539,1416.746c2.9,2.207,6.3,4.347,9.919,3.893a13.78,13.78,0,0,0-4.235-4.117c3.093.051,4.984,3.636,7.963,4.469a7.6,7.6,0,0,0,3.745-.1c3.427-.8,6.768-2.613,10.253-2.124a4.877,4.877,0,0,0-2.4-4.291,5.159,5.159,0,0,1,3.31,2.116,2.924,2.924,0,0,0,.837.969,2.273,2.273,0,0,0,1.214.183c3.586-.121,7.135-1.053,10.724-.507a6.366,6.366,0,0,0-.695-4.545c1.069-.066,1.885.935,2.364,1.894a5.255,5.255,0,0,0,1.842,2.563,4.268,4.268,0,0,0,1.821.356l8.833.41c.806.037,1.8-.028,2.149-.755a2.059,2.059,0,0,0-.005-1.373c-.617-2.558-1.6-5.3-3.883-6.614-2.686-1.541-6.053-.51-9.138-.758a19.435,19.435,0,0,1,8.042-1.111,32.1,32.1,0,0,0-14.153-12.016,22.443,22.443,0,0,1-10.145,1.992,30.963,30.963,0,0,0,8.051-2.574c-6.422-3.028-13.111-6.118-20.211-6.122-4.551,0-9.117,1.273-13.606.531-.679,2.938-5.05,4.314-4.863,7.323a7.033,7.033,0,0,1,2.356-5.822,16.059,16.059,0,0,0-9.394,5.164,11.579,11.579,0,0,0-2.894,5.718c-.455,2.822.383,5.992-1.177,8.387-.2.3-.438.658-.3.991.121.291.47.4.776.47,2.346.552,4.571.311,6.825,1.343A33.842,33.842,0,0,1,3316.539,1416.746Z",
    transform: "translate(-3302.818 -1388.585)",
    fill: "#c3eabe"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_11596",
    "data-name": "Trac\\xE9 11596",
    d: "M3303.358,1573.329q2.046-.981,4.158-1.816t4.281-1.505q2.169-.667,4.375-1.2c1.473-.345,2.956-.65,4.447-.9a70.911,70.911,0,0,1,18.091-.7l.283.023.282.029.564.059.564.059c.188.02.375.046.563.069.375.048.751.093,1.126.143l1.122.166.28.041.28.047.559.095.559.1c.187.031.372.07.558.1l1.113.216,1.109.239c.371.076.737.171,1.1.256s.737.173,1.1.273l1.1.289,1.091.313.272.079.271.084.542.169.542.169c.181.056.359.12.538.179.358.122.717.24,1.074.365l1.066.388a63.869,63.869,0,0,1,15.9,8.637l-.007.01a63.837,63.837,0,0,0-15.9-8.615l-1.066-.386c-.356-.125-.716-.242-1.074-.364-.179-.059-.357-.123-.538-.179l-.542-.168-.541-.168-.271-.084-.272-.078-1.09-.312-1.1-.288c-.365-.1-.732-.185-1.1-.272s-.734-.181-1.1-.256l-1.109-.239-1.113-.216c-.186-.034-.371-.074-.558-.1l-.559-.1-.559-.095-.28-.047-.28-.042-1.122-.166c-.375-.051-.75-.1-1.125-.143-.187-.023-.374-.049-.562-.069l-.564-.058-.564-.059-.282-.029-.283-.024a70.872,70.872,0,0,0-18.08.7,66.167,66.167,0,0,0-17.263,5.4Z",
    transform: "translate(-3303.31 -1551.106)",
    fill: "#a9d3a3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_11597",
    "data-name": "Trac\\xE9 11597",
    d: "M3714.862,1576.321a2.115,2.115,0,0,1,.869.166,2.846,2.846,0,0,1,.754.469,4.336,4.336,0,0,1,1.064,1.41c.517,1.07.721,2.254,1.231,3.318a7.467,7.467,0,0,0,.948,1.485,10.984,10.984,0,0,0,1.227,1.271,27.765,27.765,0,0,0,2.833,2.119l-.006.01a26.306,26.306,0,0,1-2.85-2.1,10.531,10.531,0,0,1-1.235-1.271,7.486,7.486,0,0,1-.954-1.494c-.513-1.071-.718-2.255-1.231-3.318a4.279,4.279,0,0,0-1.054-1.4,2.93,2.93,0,0,0-.742-.466,2.3,2.3,0,0,0-.854-.189Z",
    transform: "translate(-3678.327 -1559.674)",
    fill: "#a9d3a3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_11598",
    "data-name": "Trac\\xE9 11598",
    d: "M3846.921,1599.172a9.791,9.791,0,0,1,.8.841,5.628,5.628,0,0,1,.659.957,3.788,3.788,0,0,1,.235.532,5.048,5.048,0,0,1,.165.558,10.969,10.969,0,0,1,.191,1.146,9.059,9.059,0,0,0,.454,2.262,3.913,3.913,0,0,0,.248.521,2.9,2.9,0,0,0,.329.473,2.421,2.421,0,0,0,.42.394,2.219,2.219,0,0,0,.507.273l0,.011a2.234,2.234,0,0,1-.515-.267,2.32,2.32,0,0,1-.428-.393,3.024,3.024,0,0,1-.336-.475,3.916,3.916,0,0,1-.253-.523,5.205,5.205,0,0,1-.185-.552,5.662,5.662,0,0,1-.123-.568c-.065-.382-.107-.767-.156-1.15a10.687,10.687,0,0,0-.191-1.141,4.842,4.842,0,0,0-.163-.553,3.905,3.905,0,0,0-.232-.528,5.572,5.572,0,0,0-.654-.949c-.249-.3-.516-.574-.776-.86Z",
    transform: "translate(-3798.669 -1580.5)",
    fill: "#a9d3a3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_11599",
    "data-name": "Trac\\xE9 11599",
    d: "M3969.18,1635.464c.143-.052.286-.1.431-.147s.294-.074.441-.11l.447-.082.452-.055a8.067,8.067,0,0,1,1.816.039,7.818,7.818,0,0,1,1.76.446,7.429,7.429,0,0,1,1.6.845l-.007.01a7.821,7.821,0,0,0-1.61-.822,8.248,8.248,0,0,0-1.753-.438,8.009,8.009,0,0,0-1.806-.038l-.449.055-.445.081c-.147.036-.293.072-.44.106s-.29.083-.437.122Z",
    transform: "translate(-3910.094 -1613.184)",
    fill: "#a9d3a3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_11600",
    "data-name": "Trac\\xE9 11600",
    d: "M3959.451,1641.086a2.372,2.372,0,0,1,.605.753,4.706,4.706,0,0,1,.355.9c.182.62.29,1.258.48,1.872a4.706,4.706,0,0,0,.366.888,3.282,3.282,0,0,0,.582.76,3.347,3.347,0,0,0,1.685.877l0,.011a3.3,3.3,0,0,1-1.708-.863,3.2,3.2,0,0,1-.593-.766,4.667,4.667,0,0,1-.37-.9c-.191-.618-.3-1.256-.48-1.873a4.719,4.719,0,0,0-.352-.894,3.064,3.064,0,0,0-.577-.764Z",
    transform: "translate(-3901.22 -1618.697)",
    fill: "#a9d3a3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_11601",
    "data-name": "Trac\\xE9 11601",
    d: "M3862.154,1569.6c.2-.016.4-.035.6-.056s.4-.05.592-.082a9.505,9.505,0,0,0,1.162-.271,13.044,13.044,0,0,0,2.2-.928c.355-.181.71-.365,1.067-.543s.721-.344,1.092-.493a8.275,8.275,0,0,1,1.143-.359,5.527,5.527,0,0,1,1.19-.123v.011a5.8,5.8,0,0,0-1.184.137,8.268,8.268,0,0,0-1.135.366c-.369.151-.729.322-1.087.5s-.711.361-1.067.542a13.116,13.116,0,0,1-2.205.931,9.681,9.681,0,0,1-1.167.271,7.38,7.38,0,0,1-1.193.109Z",
    transform: "translate(-3812.558 -1550.945)",
    fill: "#a9d3a3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_11602",
    "data-name": "Trac\\xE9 11602",
    d: "M3721.115,1507.283a12.628,12.628,0,0,0,1.332-.805c.428-.295.833-.621,1.231-.955.8-.668,1.557-1.379,2.374-2.025a13.705,13.705,0,0,1,1.278-.9,9.969,9.969,0,0,1,1.393-.706,10.336,10.336,0,0,1,3.021-.75v.012a10.6,10.6,0,0,0-3.008.771,10.456,10.456,0,0,0-1.385.709,13.54,13.54,0,0,0-1.274.9c-.815.645-1.576,1.355-2.374,2.025-.4.334-.8.661-1.234.957a8.533,8.533,0,0,1-1.351.782Z",
    transform: "translate(-3684.025 -1491.163)",
    fill: "#a9d3a3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_11603",
    "data-name": "Trac\\xE9 11603",
    d: "M3575.209,1458.383a7.023,7.023,0,0,0,1.723-.915,9.375,9.375,0,0,0,1.447-1.314,23.165,23.165,0,0,0,2.3-3.167,24.41,24.41,0,0,1,2.292-3.185,9.718,9.718,0,0,1,1.437-1.335,6.57,6.57,0,0,1,1.722-.933l0,.011a6.7,6.7,0,0,0-1.709.943,9.661,9.661,0,0,0-1.426,1.338,25.294,25.294,0,0,0-2.284,3.183,23.287,23.287,0,0,1-2.308,3.172,9.453,9.453,0,0,1-1.454,1.32,6.04,6.04,0,0,1-1.744.892Z",
    transform: "translate(-3551.056 -1442.307)",
    fill: "#a9d3a3"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_3387",
    "data-name": "Groupe 3387",
    transform: "translate(9.983 3.233)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_3386",
    "data-name": "Groupe 3386"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_11604",
    "data-name": "Trac\\xE9 11604",
    d: "M3415.407,1440.078a5.14,5.14,0,0,0,1.04-.6,5.607,5.607,0,0,0,.862-.836,7.871,7.871,0,0,0,1.2-2.081,11.491,11.491,0,0,0,.387-1.142c.11-.387.2-.78.285-1.173.169-.788.312-1.582.49-2.37a13.286,13.286,0,0,1,.712-2.313,7.571,7.571,0,0,1,1.282-2.048,7.791,7.791,0,0,1,4.084-2.466l0,.015a7.84,7.84,0,0,0-4.053,2.481,7.673,7.673,0,0,0-1.268,2.039,13.263,13.263,0,0,0-.709,2.3c-.178.786-.32,1.58-.489,2.369-.086.394-.175.788-.286,1.177a11.5,11.5,0,0,1-.389,1.148,7.908,7.908,0,0,1-1.207,2.095,5.267,5.267,0,0,1-.874.841,4.436,4.436,0,0,1-1.063.577Z",
    transform: "translate(-3415.407 -1425.047)",
    fill: "#633c8c"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_11605",
    "data-name": "Trac\\xE9 11605",
    d: "M3577.281,1570.462a3.821,3.821,0,0,1,1.808.623,5.478,5.478,0,0,1,.763.59c.114.113.234.221.341.341.054.059.11.117.164.177l.155.185c.053.061.1.124.15.188l.146.191c.091.133.188.261.274.4l.13.2c.043.068.083.138.124.207.085.137.16.279.238.419.3.567.571,1.151.844,1.731s.55,1.159.873,1.713c.158.279.334.547.517.809.1.128.188.26.292.381.051.061.1.125.153.185l.161.178a7.474,7.474,0,0,0,1.485,1.21,13.4,13.4,0,0,0,1.7.9l0,.011a12.891,12.891,0,0,1-1.709-.884,7.478,7.478,0,0,1-1.5-1.208l-.164-.178c-.053-.06-.1-.124-.154-.185-.1-.122-.2-.254-.294-.382-.186-.262-.362-.532-.521-.811-.323-.555-.6-1.136-.874-1.716s-.542-1.163-.843-1.729c-.078-.14-.152-.282-.236-.418-.042-.069-.082-.138-.124-.206l-.13-.2c-.085-.135-.182-.263-.272-.4l-.146-.19c-.048-.064-.1-.127-.15-.187l-.155-.184c-.053-.06-.108-.117-.162-.176-.106-.12-.225-.227-.339-.339a5.432,5.432,0,0,0-.757-.585,4.18,4.18,0,0,0-1.786-.647Z",
    transform: "translate(-3552.944 -1554.335)",
    fill: "#a9d3a3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_11606",
    "data-name": "Trac\\xE9 11606",
    d: "M3416.37,1598.13a5.648,5.648,0,0,1,1.088.075,6.6,6.6,0,0,1,1.055.283,8.4,8.4,0,0,1,1,.445,10.5,10.5,0,0,1,.934.567c.3.207.589.428.87.659s.549.479.812.73c.525.5,1.023,1.034,1.519,1.566s.991,1.063,1.51,1.572q.39.38.8.739c.276.236.56.462.853.676s.6.408.916.588a8.733,8.733,0,0,0,.979.473,7.287,7.287,0,0,0,1.039.322,6.313,6.313,0,0,0,1.08.131v.012a6.339,6.339,0,0,1-1.083-.126,7.263,7.263,0,0,1-1.043-.317,8.879,8.879,0,0,1-.985-.47c-.317-.179-.623-.376-.921-.585s-.582-.438-.859-.673-.542-.486-.8-.739c-.52-.509-1.016-1.042-1.511-1.573s-.994-1.061-1.518-1.564c-.263-.25-.532-.494-.81-.728s-.568-.451-.867-.657a10.454,10.454,0,0,0-.93-.564,8.456,8.456,0,0,0-.992-.443,7.537,7.537,0,0,0-1.047-.287,6.717,6.717,0,0,0-1.082-.1Z",
    transform: "translate(-3406.302 -1579.548)",
    fill: "#a9d3a3"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_3391",
    "data-name": "Groupe 3391",
    transform: "translate(1357.54 665.691)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_11607",
    "data-name": "Trac\\xE9 11607",
    d: "M3244.246,807.348c2.258-2.864,4.457-6.224,4.067-9.849a13.784,13.784,0,0,0-4.191,4.163c.105-3.092,3.723-4.92,4.608-7.884a7.591,7.591,0,0,0-.034-3.746c-.736-3.441-2.493-6.813-1.943-10.289a4.876,4.876,0,0,0-4.333,2.329,5.157,5.157,0,0,1,2.174-3.273,2.916,2.916,0,0,0,.983-.82,2.272,2.272,0,0,0,.2-1.211c-.058-3.588-.928-7.153-.319-10.731a6.368,6.368,0,0,0-4.556.615c-.047-1.07.968-1.868,1.935-2.33a5.258,5.258,0,0,0,2.6-1.8,4.263,4.263,0,0,0,.388-1.815l.565-8.824c.051-.806,0-1.8-.717-2.163a2.064,2.064,0,0,0-1.373-.018c-2.569.573-5.333,1.508-6.681,3.767-1.587,2.658-.617,6.042-.918,9.124a19.431,19.431,0,0,1-.97-8.061,32.113,32.113,0,0,0-12.262,13.94,22.452,22.452,0,0,1,1.814,10.178,30.994,30.994,0,0,0-2.433-8.1c-3.14,6.368-6.347,13-6.475,20.1-.083,4.55,1.113,9.138.292,13.614,2.926.73,4.224,5.125,7.237,4.99a7.034,7.034,0,0,1-5.78-2.457,16.065,16.065,0,0,0,5,9.483,11.579,11.579,0,0,0,5.667,2.993c2.814.5,6-.278,8.366,1.323.3.2.65.45.985.318.293-.116.406-.463.483-.768.592-2.336.39-4.565,1.462-6.8A33.8,33.8,0,0,1,3244.246,807.348Z",
    transform: "translate(-3216.37 -749.597)",
    fill: "#c3eabe"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_11608",
    "data-name": "Trac\\xE9 11608",
    d: "M3400.343,846.921q-.946-2.063-1.743-4.189t-1.43-4.307q-.629-2.18-1.125-4.4c-.319-1.479-.6-2.966-.827-4.462a70.882,70.882,0,0,1-.384-18.1l.028-.282.034-.282.068-.563.069-.563c.023-.188.052-.374.079-.562.055-.374.105-.749.163-1.123l.186-1.119.046-.28.052-.279.1-.558.1-.557c.033-.186.077-.37.114-.556l.235-1.11.258-1.1c.082-.369.184-.734.275-1.1s.186-.733.292-1.1l.309-1.092.333-1.085.083-.271.089-.269.179-.539.179-.538c.06-.18.126-.356.189-.535.128-.356.252-.713.384-1.067l.407-1.059a63.877,63.877,0,0,1,8.914-15.742l.01.007a63.863,63.863,0,0,0-8.893,15.747l-.4,1.059c-.132.354-.255.712-.383,1.067-.062.178-.129.355-.188.535l-.178.539-.178.538-.088.269-.083.271-.331,1.085-.308,1.091c-.106.363-.2.73-.292,1.1s-.193.731-.276,1.1l-.258,1.1-.235,1.109c-.038.185-.08.369-.114.555l-.1.557-.1.557-.052.279-.047.28-.186,1.119c-.057.374-.108.748-.163,1.122-.026.187-.056.374-.079.562l-.068.563-.069.563-.034.281-.028.282a70.843,70.843,0,0,0,.384,18.09,66.147,66.147,0,0,0,5.094,17.355Z",
    transform: "translate(-3378.643 -775.604)",
    fill: "#a9d3a3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_11609",
    "data-name": "Trac\\xE9 11609",
    d: "M3405.438,1051.475a2.113,2.113,0,0,1,.181-.866,2.843,2.843,0,0,1,.482-.746,4.323,4.323,0,0,1,1.429-1.04c1.08-.5,2.267-.682,3.339-1.173a7.468,7.468,0,0,0,1.5-.922,11.054,11.054,0,0,0,1.292-1.2,27.79,27.79,0,0,0,2.168-2.8l.009.007a26.25,26.25,0,0,1-2.152,2.813,10.544,10.544,0,0,1-1.292,1.213,7.5,7.5,0,0,1-1.51.927c-1.08.495-2.268.678-3.339,1.173a4.285,4.285,0,0,0-1.415,1.029,2.945,2.945,0,0,0-.479.734,2.314,2.314,0,0,0-.2.851Z",
    transform: "translate(-3388.674 -1016.737)",
    fill: "#a9d3a3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_11610",
    "data-name": "Trac\\xE9 11610",
    d: "M3430.595,969.884a9.773,9.773,0,0,1,.855-.785,5.57,5.57,0,0,1,.968-.642,3.847,3.847,0,0,1,.537-.226,5.072,5.072,0,0,1,.561-.155,10.807,10.807,0,0,1,1.149-.171,9.05,9.05,0,0,0,2.27-.415,3.87,3.87,0,0,0,.525-.239,3,3,0,0,0,.479-.32,2.453,2.453,0,0,0,.4-.413,2.214,2.214,0,0,0,.282-.5l.011,0a2.217,2.217,0,0,1-.276.51,2.353,2.353,0,0,1-.4.421,2.985,2.985,0,0,1-.481.327,3.91,3.91,0,0,1-.528.245,5.185,5.185,0,0,1-.554.175c-.188.046-.379.085-.571.112-.383.059-.769.094-1.153.135a10.713,10.713,0,0,0-1.145.171,4.9,4.9,0,0,0-.556.153,3.815,3.815,0,0,0-.532.223,5.571,5.571,0,0,0-.961.638c-.3.243-.583.505-.873.761Z",
    transform: "translate(-3411.6 -946.826)",
    fill: "#a9d3a3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_11611",
    "data-name": "Trac\\xE9 11611",
    d: "M3469.462,816.935c-.049-.143-.1-.287-.14-.433s-.068-.3-.1-.443l-.074-.449-.047-.452a8.032,8.032,0,0,1,.07-1.815,7.806,7.806,0,0,1,.477-1.752,7.4,7.4,0,0,1,.873-1.59l.009.007a7.86,7.86,0,0,0-.85,1.6,8.274,8.274,0,0,0-.468,1.745,8,8,0,0,0-.07,1.805l.047.45.073.447c.034.147.067.294.1.442s.079.291.114.439Z",
    transform: "translate(-3446.67 -804.645)",
    fill: "#a9d3a3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_11612",
    "data-name": "Trac\\xE9 11612",
    d: "M3474.475,857.105a2.38,2.38,0,0,1,.763-.592,4.721,4.721,0,0,1,.908-.339c.623-.171,1.263-.268,1.881-.447a4.693,4.693,0,0,0,.895-.351,3.275,3.275,0,0,0,.771-.568,3.348,3.348,0,0,0,.906-1.669l.012,0a3.3,3.3,0,0,1-.893,1.692,3.185,3.185,0,0,1-.776.58,4.715,4.715,0,0,1-.9.354c-.621.18-1.261.277-1.881.447a4.673,4.673,0,0,0-.9.336,3.056,3.056,0,0,0-.774.563Z",
    transform: "translate(-3451.589 -843.958)",
    fill: "#a9d3a3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_11613",
    "data-name": "Trac\\xE9 11613",
    d: "M3402.9,901.085c-.013-.2-.028-.4-.045-.6s-.043-.4-.072-.593a9.606,9.606,0,0,0-.25-1.167,13.1,13.1,0,0,0-.89-2.215c-.175-.358-.352-.716-.524-1.076s-.331-.727-.474-1.1a8.325,8.325,0,0,1-.339-1.149,5.552,5.552,0,0,1-.1-1.192h.011a5.828,5.828,0,0,0,.117,1.186,8.181,8.181,0,0,0,.346,1.142c.145.371.31.734.479,1.1s.349.717.523,1.076a13.113,13.113,0,0,1,.893,2.221,9.516,9.516,0,0,1,.251,1.172,7.362,7.362,0,0,1,.088,1.195Z",
    transform: "translate(-3383.906 -879.371)",
    fill: "#a9d3a3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_11614",
    "data-name": "Trac\\xE9 11614",
    d: "M3338.429,1024.662a12.5,12.5,0,0,0-.782-1.346c-.287-.432-.606-.844-.933-1.248-.654-.807-1.352-1.581-1.983-2.41a13.506,13.506,0,0,1-.875-1.294,10.061,10.061,0,0,1-.682-1.4,10.348,10.348,0,0,1-.7-3.034h.012a10.6,10.6,0,0,0,.718,3.021,10.469,10.469,0,0,0,.685,1.4,13.448,13.448,0,0,0,.873,1.289c.63.827,1.327,1.6,1.982,2.409.328.4.647.817.936,1.251a8.544,8.544,0,0,1,.758,1.364Z",
    transform: "translate(-3322.182 -990.488)",
    fill: "#a9d3a3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_11615",
    "data-name": "Trac\\xE9 11615",
    d: "M3287.032,1166.623a7.027,7.027,0,0,0-.885-1.739,9.411,9.411,0,0,0-1.288-1.47,23.252,23.252,0,0,0-3.126-2.359,24.445,24.445,0,0,1-3.144-2.347,9.691,9.691,0,0,1-1.31-1.461,6.572,6.572,0,0,1-.9-1.738l.011,0a6.716,6.716,0,0,0,.913,1.726,9.691,9.691,0,0,0,1.313,1.45,25.335,25.335,0,0,0,3.143,2.339,23.243,23.243,0,0,1,3.131,2.363,9.467,9.467,0,0,1,1.294,1.477,6.074,6.074,0,0,1,.861,1.759Z",
    transform: "translate(-3271.057 -1119.514)",
    fill: "#a9d3a3"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_3390",
    "data-name": "Groupe 3390",
    transform: "translate(3.069 50.708)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_3389",
    "data-name": "Groupe 3389"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_11616",
    "data-name": "Trac\\xE9 11616",
    d: "M3265.824,1332.088a5.106,5.106,0,0,0-.583-1.051,5.6,5.6,0,0,0-.821-.876,7.845,7.845,0,0,0-2.059-1.235,11.6,11.6,0,0,0-1.135-.407c-.385-.117-.777-.212-1.168-.306-.785-.183-1.577-.339-2.361-.531a13.319,13.319,0,0,1-2.3-.753,7.56,7.56,0,0,1-2.025-1.318,7.788,7.788,0,0,1-2.394-4.126l.015,0a7.832,7.832,0,0,0,2.41,4.1,7.667,7.667,0,0,0,2.017,1.3,13.281,13.281,0,0,0,2.292.75c.782.191,1.574.347,2.36.531.392.094.785.189,1.171.307a11.724,11.724,0,0,1,1.141.409,7.915,7.915,0,0,1,2.074,1.243,5.282,5.282,0,0,1,.825.888,4.455,4.455,0,0,1,.559,1.074Z",
    transform: "translate(-3250.977 -1321.482)",
    fill: "#633c8c"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_11617",
    "data-name": "Trac\\xE9 11617",
    d: "M3397.162,1174.684a3.82,3.82,0,0,1,.655-1.8,5.457,5.457,0,0,1,.6-.753c.115-.113.224-.231.347-.335.06-.053.119-.108.18-.16l.188-.152c.062-.052.126-.1.191-.147l.194-.143c.134-.089.264-.184.4-.267l.205-.127c.069-.042.139-.08.208-.121.139-.082.282-.154.424-.23.572-.293,1.16-.551,1.745-.814s1.169-.53,1.729-.843c.281-.153.552-.324.818-.5.129-.094.263-.183.386-.285.063-.05.126-.1.187-.15l.18-.158a7.445,7.445,0,0,0,1.237-1.463,13.425,13.425,0,0,0,.925-1.684l.01,0a12.846,12.846,0,0,1-.913,1.694,7.5,7.5,0,0,1-1.235,1.475l-.181.16c-.061.052-.125.1-.188.152-.124.1-.257.193-.386.288-.266.181-.539.352-.821.506-.561.314-1.146.58-1.731.844s-1.173.521-1.743.813c-.142.075-.284.147-.422.229-.069.04-.139.079-.208.12l-.2.127c-.137.083-.267.177-.4.266l-.193.143c-.065.047-.129.1-.19.146l-.187.151c-.061.052-.12.106-.179.159-.122.1-.23.221-.345.333a5.433,5.433,0,0,0-.6.747,4.177,4.177,0,0,0-.678,1.775Z",
    transform: "translate(-3381.132 -1127.759)",
    fill: "#a9d3a3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_11618",
    "data-name": "Trac\\xE9 11618",
    d: "M3422.027,1293.271a5.679,5.679,0,0,1,.094-1.087,6.644,6.644,0,0,1,.3-1.05,8.557,8.557,0,0,1,.462-.99,10.567,10.567,0,0,1,.583-.924c.212-.3.438-.582.675-.859s.488-.54.744-.8c.513-.516,1.052-1.005,1.592-1.491s1.081-.972,1.6-1.482q.387-.384.752-.787c.241-.272.473-.552.69-.842s.419-.593.6-.9a8.8,8.8,0,0,0,.49-.971,7.242,7.242,0,0,0,.34-1.033,6.259,6.259,0,0,0,.15-1.077h.011a6.3,6.3,0,0,1-.145,1.081,7.3,7.3,0,0,1-.336,1.038,8.764,8.764,0,0,1-.487.976,10.79,10.79,0,0,1-.6.911c-.217.292-.448.574-.688.848s-.5.533-.753.79c-.518.511-1.059,1-1.6,1.483s-1.078.975-1.59,1.49c-.255.258-.5.523-.742.8s-.461.561-.672.855a10.391,10.391,0,0,0-.58.919,8.35,8.35,0,0,0-.46.985,7.428,7.428,0,0,0-.306,1.042,6.669,6.669,0,0,0-.118,1.08Z",
    transform: "translate(-3403.792 -1232.036)",
    fill: "#a9d3a3"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_3394",
    "data-name": "Groupe 3394",
    transform: "translate(1369.942 707.64)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_11619",
    "data-name": "Trac\\xE9 11619",
    d: "M3385.012,1224.359c5.723-1.9,12.114-2.421,17.726-.216a11.914,11.914,0,0,1,5.308,3.758,6.752,6.752,0,0,1,1.129,6.218,7.483,7.483,0,0,1-1.7,2.554,16.148,16.148,0,0,1-8.348,4.232,33.5,33.5,0,0,1-10.929.5c-9.74-1.18-19.752,2.317-28.052,7.19-.946.555-3.535,2.714-3.908,3.744,2.186-4.682,5.343-8.832,8.475-12.941,2.658-3.488,5.39-7.035,8.89-9.728C3376.863,1227.156,3381.125,1225.651,3385.012,1224.359Z",
    transform: "translate(-3356.235 -1222.698)",
    fill: "#349fbf"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_3393",
    "data-name": "Groupe 3393",
    transform: "translate(5.675 5.506)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_3392",
    "data-name": "Groupe 3392"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_11620",
    "data-name": "Trac\\xE9 11620",
    d: "M3420.237,1301.629a35.945,35.945,0,0,1,3.916-4.35,38.39,38.39,0,0,1,4.542-3.7,44.046,44.046,0,0,1,5.028-3c1.738-.892,3.523-1.687,5.33-2.427q1.355-.554,2.723-1.074c.912-.346,1.832-.677,2.769-.958a25.388,25.388,0,0,1,2.847-.7c.964-.17,1.938-.269,2.91-.345s1.947-.13,2.919-.2,1.951-.1,2.928-.085a19.8,19.8,0,0,1,5.776.853l-.013.042a17.443,17.443,0,0,0-2.853-.608,24.335,24.335,0,0,0-2.912-.189c-.973-.01-1.947.032-2.918.1s-1.945.134-2.916.213-1.939.186-2.9.36c-.478.087-.951.194-1.422.315s-.94.25-1.405.391c-.931.281-1.847.612-2.756.959s-1.816.707-2.717,1.077c-1.8.742-3.581,1.538-5.311,2.431a44.757,44.757,0,0,0-5.014,2.984,38.173,38.173,0,0,0-4.529,3.673,55.828,55.828,0,0,0-3.992,4.261Z",
    transform: "translate(-3420.237 -1284.791)",
    fill: "#126671"
  }))))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_3397",
    "data-name": "Groupe 3397",
    transform: "translate(1388.057 679.509)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_11621",
    "data-name": "Trac\\xE9 11621",
    d: "M3575.3,932.081q2.24-1.215,4.409-2.672c4.883-3.292,11.125-9.618,10.826-17.125-.147-3.7-2.591-6.4-5.433-6.789s-5.934,1.222-8.45,3.671a38.733,38.733,0,0,0-6.369,8.975c-2.959,5.321-4.914,11.042-8.281,16.071a6.8,6.8,0,0,0-1.465,3.346A56.459,56.459,0,0,0,3575.3,932.081Z",
    transform: "translate(-3560.532 -905.437)",
    fill: "#42b2cc"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_3396",
    "data-name": "Groupe 3396",
    transform: "translate(1.439 7.383)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_3395",
    "data-name": "Groupe 3395"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_11622",
    "data-name": "Trac\\xE9 11622",
    d: "M3576.763,1014.067c1.186-.838,2.4-1.629,3.6-2.442s2.387-1.646,3.543-2.52,2.282-1.786,3.363-2.749a42.4,42.4,0,0,0,3.1-3.037,47.838,47.838,0,0,0,5.255-6.906,54.488,54.488,0,0,0,4-7.713l.04.017a51.206,51.206,0,0,1-3.925,7.767,46.279,46.279,0,0,1-5.244,6.95,42.4,42.4,0,0,1-3.108,3.057c-1.088.964-2.22,1.877-3.381,2.75s-2.353,1.7-3.556,2.516-2.42,1.6-3.667,2.347Z",
    transform: "translate(-3576.763 -988.7)",
    fill: "#126671"
  }))))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_3398",
    "data-name": "Groupe 3398",
    transform: "translate(1233.998 767.064)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_124",
    "data-name": "Ellipse 124",
    cx: 9.018,
    cy: 9.018,
    r: 9.018,
    transform: "translate(26.572 12.753) rotate(-45)",
    fill: "#118c8e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_11623",
    "data-name": "Trac\\xE9 11623",
    d: "M1889.342,2119.892c4.358-3.18,8.9-3.286,12.38-1.587v-27.382h-78.649v75.812h78.649V2137.17a10.774,10.774,0,0,1-4.744,1.092c-8.335,0-14.441-9.4-7.986-18.025A1.644,1.644,0,0,1,1889.342,2119.892Z",
    transform: "translate(-1823.073 -2073.362)",
    fill: "#118c8e"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_3399",
    "data-name": "Groupe 3399",
    transform: "translate(1296.262 783.472)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2496",
    "data-name": "Rectangle 2496",
    width: 78.649,
    height: 76.965,
    transform: "translate(16.386 0)",
    fill: "#56c3c5"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_125",
    "data-name": "Ellipse 125",
    cx: 11.075,
    cy: 11.306,
    rx: 11.075,
    ry: 11.306,
    transform: "translate(0 26.687)",
    fill: "#56c3c5"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_3400",
    "data-name": "Groupe 3400",
    transform: "translate(1314.244 706.508)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_126",
    "data-name": "Ellipse 126",
    cx: 10.115,
    cy: 10.115,
    r: 10.115,
    transform: "translate(30.501 72.522)",
    fill: "#014260"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_11624",
    "data-name": "Trac\\xE9 11624",
    d: "M2806.723,1209.923h-78.65v30.557c3.012-1.639,7.061-1.613,10.912,1.32,5.665,7.438.485,15.623-6.606,15.623a8.982,8.982,0,0,1-4.306-1.092v30.557h78.65Z",
    transform: "translate(-2728.073 -1209.923)",
    fill: "#014260"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_3402",
    "data-name": "Groupe 3402",
    transform: "translate(1211.23 684.01)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_3401",
    "data-name": "Groupe 3401",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_11625",
    "data-name": "Trac\\xE9 11625",
    d: "M1651.331,963.023l-78.353-6.825h0l-6.678,76.674,31.576,2.75c-1.656-3.21-1.432-7.5,2.014-11.285,7.9-4.994,15.6.876,14.987,7.939a8.977,8.977,0,0,1-1.8,4.67l31.576,2.75Z",
    transform: "translate(-1566.3 -956.198)",
    fill: "#afd9c9"
  })), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_127",
    "data-name": "Ellipse 127",
    cx: 8.871,
    cy: 8.871,
    r: 8.871,
    transform: "translate(72.093 45.419) rotate(-45)",
    fill: "#afd9c9"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_3403",
    "data-name": "Groupe 3403",
    transform: "translate(1176.683 754.396)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_11626",
    "data-name": "Trac\\xE9 11626",
    d: "M1437.384,1778.426c1.026-.341,3.556-1.3,3.556-1.3l9.225-12.442s.049-5.367.714-4.385a6.48,6.48,0,0,1,.727,2.786,7.675,7.675,0,0,0,2.129,3.469c1.394.986-2.074.034-2.074.034s-6.765,13.5-8.43,13.9a40.09,40.09,0,0,0-4.229,1.445Z",
    transform: "translate(-1414.268 -1759.276)",
    fill: "#b89165"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_11627",
    "data-name": "Trac\\xE9 11627",
    d: "M1313.165,1962.286a39.644,39.644,0,0,1,.907,4.846s-10.473,4.352-10.968,4.478-3.013-5.6-3.013-5.6S1312.992,1962.027,1313.165,1962.286Z",
    transform: "translate(-1289.149 -1943.452)",
    fill: "#7fa1ad"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_11628",
    "data-name": "Trac\\xE9 11628",
    d: "M1300.092,2269.543l10.44,22.705-9.444,20.159,2.153,2.684s13.461-14.022,13.615-20.6-6.839-28.9-6.839-28.9Z",
    transform: "translate(-1289.149 -2219.875)",
    fill: "gray"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_11629",
    "data-name": "Trac\\xE9 11629",
    d: "M1310.838,2265.592c3.021,5.1,7.724,20.629,9,25.21,3.183,11.439,5.609,23.352,5.609,23.352l-3.6.049-10.052-24.889s-6.563-12.526-11.705-19.771Z",
    transform: "translate(-1289.149 -2219.875)",
    fill: "#b3b3b3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_11630",
    "data-name": "Trac\\xE9 11630",
    d: "M1249.772,1932.493l2.253,7.338-4.306,2.551-3.558-9.413Z",
    transform: "translate(-1238.179 -1916.312)",
    fill: "#c69c6d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_11631",
    "data-name": "Trac\\xE9 11631",
    d: "M1482.918,1750.12c-.808-.563-3.132.955-4.753,2.656s.21,5.013.21,5.013l-5.98,12.38-5.637,1.036.633,5.609c4.151-.893,8.67-2.429,9.028-3.222.894-1.984,4.357-14.752,4.357-14.752S1483.726,1750.683,1482.918,1750.12Z",
    transform: "translate(-1441.037 -1750)",
    fill: "#c69c6d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_11632",
    "data-name": "Trac\\xE9 11632",
    d: "M1188.277,1790.086c4.129-2.091,2.126-5.252,1.094-5.609a8.313,8.313,0,0,0-8.056.79c-3.212,2.371-5.43,7.113-4.36,10.173s6.484,4.233,6.509,4.3,3.134-.4-.084-4.634c-1.728-2.272,1.5-4.489,1.5-4.489Z",
    transform: "translate(-1176.683 -1780.789)",
    fill: "#252d46"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_128",
    "data-name": "Ellipse 128",
    cx: 1.367,
    cy: 2.039,
    rx: 1.367,
    ry: 2.039,
    transform: "matrix(0.751, -0.661, 0.661, 0.751, 3.875, 12.674)",
    fill: "#c69c6d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_11633",
    "data-name": "Trac\\xE9 11633",
    d: "M1266.063,2003.554c-1.588.552.918,26.254,2.556,26.254s11.342-2.854,11.342-2.854a144.791,144.791,0,0,1-1.82-15.131c-.187-5.342-.459-2.575-2.821-7.309C1273.621,2001.113,1267.65,2003,1266.063,2003.554Z",
    transform: "translate(-1257.676 -1980.14)",
    fill: "#8faebc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_11634",
    "data-name": "Trac\\xE9 11634",
    d: "M1216.838,1827.126s6.224,7.879,2.713,9.2-6.666,2.384-7.533.421-.723-.871-1.93-1.54-2.408-2.832-.864-3.035c.909-.119-.292-3.438.2-4.221S1213.87,1824.9,1216.838,1827.126Z",
    transform: "translate(-1205.672 -1819.42)",
    fill: "#c69c6d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_11635",
    "data-name": "Trac\\xE9 11635",
    d: "M1308.573,1991.521c-2.15.395-.8,5.344.393,6.052.716.426,7-1.489,13.232-2.83l-.633-5.609Z",
    transform: "translate(-1295.844 -1967.93)",
    fill: "#85a2af"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_11636",
    "data-name": "Trac\\xE9 11636",
    d: "M1216.1,1816.074s1.184,1.448-3,2.253-6.328,1.416-6.328,1.416-3.06-3.619,1.479-4.638S1216.034,1814.257,1216.1,1816.074Z",
    transform: "translate(-1203.181 -1808.765)",
    fill: "#252d46"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_11637",
    "data-name": "Trac\\xE9 11637",
    d: "M1547,2817.189s9.1,1.552,9.178,2.47-10.02.841-10.326,1.147-2.524,0-2.524,0-.615-3.6.61-3.617S1547,2817.189,1547,2817.189Z",
    transform: "translate(-1510.682 -2722.556)",
    fill: "#333"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_11638",
    "data-name": "Trac\\xE9 11638",
    d: "M1279.589,2793.568s-3.864,2.612-2.947,3.668,4.141,5.339,6.507,5.339,3.054-.459,2.289-.867-1.759-.561-2.447-.969-1.25-4.487-1.25-4.487l-2.09-2.575",
    transform: "translate(-1267.65 -2701.036)",
    fill: "#333"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_3404",
    "data-name": "Groupe 3404",
    transform: "translate(1242.574 812.789)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_11639",
    "data-name": "Trac\\xE9 11639",
    d: "M2130.247,2409.424c.307.433.415.985.731,1.412.808,1.086,2.646.994,3.38,2.131.863,1.336-.483,3.176.073,4.666a5.513,5.513,0,0,0,1.655,1.856,2.109,2.109,0,0,1,.8,2.213c-.368.843-1.524,1.022-2.076,1.759a2.668,2.668,0,0,0,.1,2.7,6.272,6.272,0,0,1,.971,2.644,3.019,3.019,0,0,1-2.9,2.693,6.174,6.174,0,0,1-4-1.482,6.207,6.207,0,0,0-1.785-1.115c-1.382-.433-2.826.369-4.007,1.207s-2.459,1.788-3.9,1.684a3.034,3.034,0,0,1-2.651-3.423c.143-.783.581-1.671.089-2.3-.3-.383-.853-.491-1.167-.861a1.683,1.683,0,0,1,.126-1.925,6.328,6.328,0,0,0,1.041-1.771,3.833,3.833,0,0,0-.906-2.8,6.739,6.739,0,0,1-1.26-2.945,2.456,2.456,0,0,1,1.476-2.6c.606-.187,1.316-.059,1.837-.421.582-.4.665-1.228,1.086-1.8a3.543,3.543,0,0,1,2.288-1.068C2123.329,2409.471,2128.632,2407.405,2130.247,2409.424Z",
    transform: "translate(-2097.276 -2408.552)",
    fill: "#254b52"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_11640",
    "data-name": "Trac\\xE9 11640",
    d: "M2070.86,3229.914a48.4,48.4,0,0,0-5.373-1.012c-1.479-.078-5.061,2.024-4.126,3.271s5.139,2.726,10.2,1.713S2070.86,3229.914,2070.86,3229.914Z",
    transform: "translate(-2048.668 -3156.16)",
    fill: "#4d4d4d"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_11641",
    "data-name": "Trac\\xE9 11641",
    d: "M2275.807,3251.777l1.838.823,1-1.8Z",
    transform: "translate(-2244.239 -3176.121)",
    fill: "#05314c"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_11642",
    "data-name": "Trac\\xE9 11642",
    d: "M2303.253,3226.573s.144-.023.384-.053c1.166-.151,4.591-.5,4.656.6.078,1.324-2.258,4.594-5.062,4.438a39.01,39.01,0,0,1-6.7-1.246l1.535-1.992Z",
    transform: "translate(-2263.129 -3153.834)",
    fill: "#4d4d4d"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_11643",
    "data-name": "Trac\\xE9 11643",
    d: "M1945.8,2988.559s-8.41-1.947-13.783-3.894-12.225-3.426-12.225,1.012,4.283,11.213,8.877,13.472,14.25,6.462,14.25,6.462-1.557,3.349-.233,3.972,30.68-7.4,33.95-18.844c0,0,2.881-7.553-6-6.774l-18.688,6.229Z",
    transform: "translate(-1919.791 -2931.859)",
    fill: "#022435"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_11644",
    "data-name": "Trac\\xE9 11644",
    d: "M2026.776,3045.3c-6.518-5.628-8.229-5.774-15.546-10.286q-1.5-.925-3.006-1.84c-.7-.426-2.581-1.183-2.839-1.878.711-.091,2,.962,2.656,1.341q1.415.814,2.812,1.659,2.749,1.66,5.427,3.435,5.4,3.578,10.487,7.6C2028.639,3046.808,2024.969,3043.738,2026.776,3045.3Z",
    transform: "translate(-1997.795 -2976.071)",
    fill: "#4d4d4d",
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  }), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_11645",
    "data-name": "Trac\\xE9 11645",
    d: "M2074.2,2692.062l-7.4,1.636-1.947-6.931-1.636,16.819h-18.61l.233-17.209-1.324,10.98-6.93-2.258.468-4.75,4.516-13.938a2.144,2.144,0,0,1,.172-.284l.743-.787a29.593,29.593,0,0,1,6.249-3.523c5.606-1.246,5.42-.233,8.955-.389s8.643,4.517,8.643,4.517Z",
    transform: "translate(-2026.233 -2647.898)",
    fill: "#7ca6a0"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_11646",
    "data-name": "Trac\\xE9 11646",
    d: "M2171.912,2673.073a2.85,2.85,0,0,0,.277,2.165,12.72,12.72,0,0,0,2.392,3.558,21.535,21.535,0,0,1,2.659,2.841,11.711,11.711,0,0,1,1.421,5.343c-.645-2.01.214-4.194,1.333-5.984s2.532-3.447,3.163-5.462a4.5,4.5,0,0,0-.5-3.655c-.528-.566-1.26-.5-2.025-.623a25.687,25.687,0,0,0-5.411.069C2174.092,2671.384,2172.365,2671.932,2171.912,2673.073Z",
    transform: "translate(-2149.448 -2647.843)",
    fill: "#f2f2f2"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_11647",
    "data-name": "Trac\\xE9 11647",
    d: "M2199.821,2609.989a6.1,6.1,0,0,0,.935,4.056,3.5,3.5,0,0,0,5.616-.153,5.963,5.963,0,0,0,.652-4.223,16.051,16.051,0,0,1-.352-4.346c-1.931.331-3.865.5-5.815.649-.973.074-1.013.208-.956,1.167A28.491,28.491,0,0,1,2199.821,2609.989Z",
    transform: "translate(-2174.98 -2587.875)",
    fill: "#cea28b"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_11648",
    "data-name": "Trac\\xE9 11648",
    d: "M2181.766,2467.479a8.869,8.869,0,0,1-2.08,4.742,5.873,5.873,0,0,1-4.667,2,5.99,5.99,0,0,1-4.833-3.766c-.846-2.04-.491-4.191-.44-6.325,0-.114.011-.229.023-.344a6.1,6.1,0,0,1,2.784-4.231,6.964,6.964,0,0,1,4-.711,5.64,5.64,0,0,1,3.463,1.149,5.246,5.246,0,0,1,1.4,2.524,11.995,11.995,0,0,1,.342,4.962Z",
    transform: "translate(-2147.476 -2454.359)",
    fill: "#e4b69d"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_11649",
    "data-name": "Trac\\xE9 11649",
    d: "M2183.306,2465.118a2.754,2.754,0,0,1-2.069-.147,1.818,1.818,0,0,1-.952-1.941,7.393,7.393,0,0,1-2.782,1.619,2.528,2.528,0,0,1-2.827-1.042c.185.355-2.944.283-3.465.178a6.1,6.1,0,0,1,2.783-4.231,6.965,6.965,0,0,1,4-.711,5.639,5.639,0,0,1,3.463,1.149,5.246,5.246,0,0,1,1.4,2.524A11.963,11.963,0,0,1,2183.306,2465.118Z",
    transform: "translate(-2148.918 -2454.359)",
    fill: "#f2f2f2",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_11650",
    "data-name": "Trac\\xE9 11650",
    d: "M2313.353,2910.977s.5,2.729.032,3.741-9.656,10.59-9.656,10.59l-2.8-3.193,6.774-9.889Z",
    transform: "translate(-2267.131 -2866.427)",
    fill: "#e4b69d"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_11651",
    "data-name": "Trac\\xE9 11651",
    d: "M2036.59,2940.877s6.152,10.9,7.4,11.135,3.271-1.947,3.271-1.947l-3.7-7.277Z",
    transform: "translate(-2026.233 -2893.677)",
    fill: "#e4b69d"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_11652",
    "data-name": "Trac\\xE9 11652",
    d: "M2068.205,2863.029l4.127,19.856h23.049l4.361-20.168Z",
    transform: "translate(-2055.045 -2822.447)",
    fill: "#254b52"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_11653",
    "data-name": "Trac\\xE9 11653",
    d: "M2068.205,2853.936v1.09l31.537-.312v-.779Z",
    transform: "translate(-2055.045 -2814.444)",
    fill: "#31595c"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_11654",
    "data-name": "Trac\\xE9 11654",
    d: "M2177.441,2448.5c-.4.715-1.382,1.263-2.03.758-.906-.7-.04-2.433-.9-3.195-1-.2-1.834.691-2.52,1.44s-1.771,1.484-2.633.948a2.408,2.408,0,0,1-.772-2.078,3.556,3.556,0,0,1-1.975,1.548,2.322,2.322,0,0,1-2.347-.636,2.036,2.036,0,0,1-.16-2.409,4.477,4.477,0,0,1,2.016-1.871,11.719,11.719,0,0,1,6.575-.811,6.9,6.9,0,0,1,4.079,2.01,4.285,4.285,0,0,1,.89,1.6A3.445,3.445,0,0,1,2177.441,2448.5Z",
    transform: "translate(-2142.154 -2439.068)",
    fill: "#254b52"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_11655",
    "data-name": "Trac\\xE9 11655",
    d: "M2180.176,2457.814a2.852,2.852,0,0,1-.223.5c-.4.715-1.382,1.263-2.031.758-.906-.7-.04-2.434-.9-3.195-1-.2-1.834.691-2.52,1.44s-1.771,1.483-2.633.948a2.406,2.406,0,0,1-.771-2.078,3.562,3.562,0,0,1-1.976,1.548,2.323,2.323,0,0,1-2.347-.636,2.022,2.022,0,0,1-.16-.213,4.475,4.475,0,0,1,2.016-1.87,11.715,11.715,0,0,1,6.575-.811,6.894,6.894,0,0,1,4.079,2.01A4.27,4.27,0,0,1,2180.176,2457.814Z",
    transform: "translate(-2144.731 -2450.013)",
    fill: "#e6e6e6",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_11656",
    "data-name": "Trac\\xE9 11656",
    d: "M2098.286,2727.65a11.822,11.822,0,0,0-1.268-7.024,3.779,3.779,0,0,0-1.081-1.36c-.265-.183-.907-.231-1.089-.444a1.081,1.081,0,0,1-.113-.153l.743-.787a1.927,1.927,0,0,1,.779.06,4.852,4.852,0,0,1,2.974,4.293A14.253,14.253,0,0,1,2098.286,2727.65Z",
    transform: "translate(-2079.222 -2690.44)",
    fill: "#1a1a1a",
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_11657",
    "data-name": "Trac\\xE9 11657",
    d: "M2342.138,2723.942c-.49,1-1.17,2.044-1.5,2.889-.5,1.253-1.87,3.873-1.624,5.226a10.752,10.752,0,0,1,2.621-8.955Z",
    transform: "translate(-2301.702 -2695.212)",
    fill: "#1a1a1a",
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_11658",
    "data-name": "Trac\\xE9 11658",
    d: "M2189.035,2423.692c.291-.049.678-.021.765.261s-.209.517-.465.656a18.092,18.092,0,0,1-3.475,1.456C2185.37,2424.71,2188.1,2423.853,2189.035,2423.692Z",
    transform: "translate(-2162.214 -2422.332)",
    fill: "#1a1a1a",
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  })), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_3406",
    "data-name": "Groupe 3406",
    transform: "translate(1288.148 657.527)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_11659",
    "data-name": "Trac\\xE9 11659",
    d: "M2518.627,978.956l-16.779,9.6-1.848-.662,1.395,3.06v3.718l3.6-3.788,17.21-8.368Z",
    transform: "translate(-2494.128 -950.455)",
    fill: "#e0ada6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_11660",
    "data-name": "Trac\\xE9 11660",
    d: "M2717.227,929.9l-7.154,4.35,3.577,3.559,11.295-6.505Z",
    transform: "translate(-2685.573 -905.75)",
    fill: "#3a9de3"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_3405",
    "data-name": "Groupe 3405",
    transform: "translate(29.319 9.559)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_11661",
    "data-name": "Trac\\xE9 11661",
    d: "M2791.038,968.751c-3.912-2.142-16.936-7.552-16.241-1.432.516,4.544,12.054,16.276,12.054,16.276l-6.019,2.66h13.6l-7.016-10.842s6.174,7.767,8.7,9.3c2.394,1.458,7.813.152,8.371-2.379Z",
    transform: "translate(-2773.853 -946.834)",
    fill: "#333"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_11662",
    "data-name": "Trac\\xE9 11662",
    d: "M2795.1,800.408c5.618-13.189-18.38-35.078-26.519-35.078s-1.824,14.592-1.824,14.592l16.276,8.138s-.538-.327-1.426-.813l13.445,13.588A2.317,2.317,0,0,1,2795.1,800.408Z",
    transform: "translate(-2764.426 -765.33)",
    fill: "#3fa9f5"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_11663",
    "data-name": "Trac\\xE9 11663",
    d: "M2437.586,918.62l17.456-10.873,2.162,4.443-16.683,9.36s-4,7.454-6,5.665,1.4-6.735,1.4-7.156-2.153-1.812-2.153-1.812C2434.159,917.288,2437.781,918.5,2437.586,918.62Z",
    transform: "translate(-2433.772 -885.56)",
    fill: "#e0ada6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_11664",
    "data-name": "Trac\\xE9 11664",
    d: "M2690.917,830.07l-14.733,6.332-2.525-5.192s10.365-6.718,12.535-7.39C2688.157,823.212,2690.917,827.606,2690.917,830.07Z",
    transform: "translate(-2652.388 -809.023)",
    fill: "#3a9de3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_11665",
    "data-name": "Trac\\xE9 11665",
    d: "M2599.006,680.375s8.4,7.934,11.834,4.471c3.254-3.282,1.062-8.473,1.062-8.473s-8.1-8.837-12.9-5.259S2599.006,680.375,2599.006,680.375Z",
    transform: "translate(-2582.414 -669.132)",
    fill: "#e0ada6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_11666",
    "data-name": "Trac\\xE9 11666",
    d: "M2576.011,666.171s-.446-.455-6.128-.086-4.561,7.6-9.966,5.406c-4.3-1.748-5.261-7.913,0-11.7S2577.389,656.247,2576.011,666.171Z",
    transform: "translate(-2545.455 -657.527)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_129",
    "data-name": "Ellipse 129",
    cx: 1.158,
    cy: 2.21,
    rx: 1.158,
    ry: 2.21,
    transform: "matrix(0.45, -0.893, 0.893, 0.45, 22.251, 7.294)",
    fill: "#e0ada6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_11667",
    "data-name": "Trac\\xE9 11667",
    d: "M2755.507,748.43l4.162,2.991a1.581,1.581,0,0,1,.091,2.5l-1.462,1.222a1.349,1.349,0,0,1-1.547.129l-1.993-1.167Z",
    transform: "translate(-2726.297 -740.37)",
    fill: "#e0ada6"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_3410",
    "data-name": "Groupe 3410",
    transform: "translate(1385.857 777.561)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_3409",
    "data-name": "Groupe 3409",
    transform: "translate(0 3.838)"
  }, _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_11668",
    "data-name": "Trac\\xE9 11668",
    d: "M3712.074,2572.85c-.22.308,2.592,3.164,2.855,8.172s-5.4,24.869-5.4,24.869l-12.566-.659s1.406-28.032,4.745-31.679Z",
    transform: "translate(-3682.663 -2526.892)",
    fill: "#bdccd4"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_11669",
    "data-name": "Trac\\xE9 11669",
    d: "M3719.4,2278.746a2.743,2.743,0,0,1-.123.756c-1.479,2.415-10.847,1.949-10.847,1.949s-.8-3.514-1.638-7.621c-.042-.2-.084-.411-.126-.618-.165-.811-.329-1.638-.488-2.461q-.086-.446-.17-.888a54.932,54.932,0,0,1-1.143-8.068c.089-3.559,5.185-9.534,8.217-10.149a6.027,6.027,0,0,1,5.183,1.627,6.547,6.547,0,0,1,1.012,2.942C3719.677,2258.314,3719.736,2274.933,3719.4,2278.746Z",
    transform: "translate(-3689.869 -2234.072)",
    fill: "#1682a8"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_11670",
    "data-name": "Trac\\xE9 11670",
    d: "M3776.7,2152.563a2.965,2.965,0,0,0,3.331,1.541,3.01,3.01,0,0,0,1.769-2.076,8.892,8.892,0,0,0,.188-2.816l-.3-7.639c-.022-.565-5.285,1.59-5.681,3.248C3775.549,2146.718,3775.755,2150.894,3776.7,2152.563Z",
    transform: "translate(-3754.486 -2133.772)",
    fill: "#e4b69d"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_11671",
    "data-name": "Trac\\xE9 11671",
    d: "M3759.238,2237.8a2.262,2.262,0,0,0-.971.283,2.318,2.318,0,0,0-.7,1.919,2.215,2.215,0,0,1-.744,1.9.8.8,0,0,0,.889-.555l.476.791a.413.413,0,0,0,.541-.162.448.448,0,0,0,.767-.126.483.483,0,0,1,.246.589c.807-.586,1.915-.347,2.9-.223.575.072,2.03.175,2.433-.242a2.755,2.755,0,0,0,.609-1.1c.231-.96.218-3.525-1.153-3.768a9.957,9.957,0,0,0-2.56.331Z",
    transform: "translate(-3737.215 -2220.891)",
    fill: "#014260"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_11672",
    "data-name": "Trac\\xE9 11672",
    d: "M3726.96,2061.053c-.087,2.344-.205,5.4-2.265,6.525a16.876,16.876,0,0,1-7.7,1.641c-.2-.008-.522-.3-.878-.8a7.37,7.37,0,0,1-.461-.749c-.1-.18-.2-.374-.291-.581-.076-.164-.151-.336-.223-.516a12.088,12.088,0,0,1-.519-1.616c-.809-.111-1.34.376-1.318-.439.038-1.445.652-4.62.853-6.079a4.081,4.081,0,0,1,2.352-3.283,9.423,9.423,0,0,1,4.239-.6,7.306,7.306,0,0,1,4.231,1.059C3726.59,2056.813,3727.035,2059.045,3726.96,2061.053Z",
    transform: "translate(-3697.557 -2054.545)",
    fill: "#e4b69d"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_11673",
    "data-name": "Trac\\xE9 11673",
    d: "M3728.468,2310.1a42.2,42.2,0,0,1-3.462,3.54c-2.118,2.142-3.888,4.709-6.466,6.267-.035.022-.072.042-.108.063-.165-.811-.329-1.638-.488-2.461q-.086-.445-.17-.889a54.628,54.628,0,0,0,8.162-11.2,2.954,2.954,0,0,0,.5-1.614c-.068-.812-.837-.369-1.515-.319,2.269-1.363,4.924-.5,5.156,2.051A6.652,6.652,0,0,1,3728.468,2310.1Z",
    transform: "translate(-3701.63 -2280.831)",
    fill: "#e6e6e6",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_11674",
    "data-name": "Trac\\xE9 11674",
    d: "M3591.464,2310.709c-3.345-3.017-7.437-5.431-10.783-8.447-.381-.344-2.654-1.465-2.557-.345s10.214,14.145,12.609,14.627,11.235-11.334,11.254-12.654c.046-3.112-3.192-4.658-5.215-2.144C3594.686,2304.338,3593.446,2307.944,3591.464,2310.709Z",
    transform: "translate(-3574.362 -2278.683)",
    fill: "#efc7b0"
  })), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_3407",
    "data-name": "Groupe 3407",
    transform: "translate(15.221 78.543)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_11675",
    "data-name": "Trac\\xE9 11675",
    d: "M3711.193,3196.129c-.084,0-1.12,1.035-1.289,1.143-.688.442-3.933,1.3-1.819,2.236s7.358-3.271,7.358-3.271v2.9h.688s.811-7.207.036-7.75C3715.018,3192.935,3713.627,3196.01,3711.193,3196.129Z",
    transform: "translate(-3707.38 -3169.129)",
    fill: "#ff7bac"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_11676",
    "data-name": "Trac\\xE9 11676",
    d: "M3815.454,3167.31c-.077.034-.67,1.369-.788,1.531-.482.662-3.2,2.636-.888,2.743s5.679-5.71,5.679-5.71l1.048,2.705.643-.249s-2.305-6.2-3.224-6.429C3817.41,3163.758,3817.681,3166.319,3815.454,3167.31Z",
    transform: "translate(-3803.507 -3142.256)",
    fill: "#ff7bac"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_11677",
    "data-name": "Trac\\xE9 11677",
    d: "M3748.136,2940.615l-4.973-.274,2.444,23.825s-3.116,4.173-3.04,4.169c2.434-.119,4.517-4.187,5.667-5.733a.165.165,0,0,0-.036-.02S3748.646,2942.541,3748.136,2940.615Z",
    transform: "translate(-3739.446 -2940.341)",
    fill: "#e2baa6"
  }))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_3408",
    "data-name": "Groupe 3408",
    transform: "translate(16.014 78.429)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_11678",
    "data-name": "Trac\\xE9 11678",
    d: "M3730.527,2960.067c.3-.012-6.211-18.518-7.1-20.632l-7.1-.373,12.4,21.793-1.248,3.461C3729.527,2964.438,3730.516,2960.067,3730.527,2960.067Z",
    transform: "translate(-3716.325 -2939.062)",
    fill: "#efc7b0"
  }))), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_11679",
    "data-name": "Trac\\xE9 11679",
    d: "M3760.32,2558.375l-9.687,1.967v3.492l10.694-3.182-.318-1.539v-.738Z",
    transform: "translate(-3731.577 -2513.701)",
    fill: "#0f596d"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_11680",
    "data-name": "Trac\\xE9 11680",
    d: "M3733.6,2578.9l-.417,3.868,1.548-.229V2578.9Z",
    transform: "translate(-3715.671 -2532.402)",
    fill: "#1b1464"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_11681",
    "data-name": "Trac\\xE9 11681",
    d: "M3538.226,2139.016l3.639,12.883,4.966-2.409-3.442-12.048Z",
    transform: "translate(-3538.003 -2130.092)",
    fill: "#534741"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_11682",
    "data-name": "Trac\\xE9 11682",
    d: "M3543.872,2142.732l3.535,12.184,4.366-2.118-3.279-11.474Z",
    transform: "translate(-3543.149 -2133.629)",
    fill: "#c5e4ef"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_11683",
    "data-name": "Trac\\xE9 11683",
    d: "M3542.039,2208.255s-1.151-6.592-1.476-6.835c-.59-.443-.934,2.557-.934,2.557s-.3,2.389-1.278-2.853l-1.377-3.786a5.982,5.982,0,0,0,.2,7.573c3.146,4.131,3.1,4.377,3.1,4.377Z",
    transform: "translate(-3535.719 -2184.676)",
    fill: "#efc7b0"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_11684",
    "data-name": "Trac\\xE9 11684",
    d: "M3734.234,2232.435l-1.284,3.033a7.37,7.37,0,0,1-.461-.749c-.1-.181-.2-.374-.291-.581-.076-.164-.151-.337-.223-.516Z",
    transform: "translate(-3714.573 -2216.661)",
    fill: "#f2f2f2"
  }))), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_11685",
    "data-name": "Trac\\xE9 11685",
    d: "M3706.11,2011.836s-4.245,4.942-1.708,7.651,8.394-.534,9.929,3.32-.328,11.3,2.436,15.707,13.1,8.86,12.621-.271-6.508-6.355-6.508-10.483-.374-12.1-6.113-14.968S3708.369,2012,3706.11,2011.836Z",
    transform: "translate(-3688.708 -2011.261)",
    fill: "#333"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPuzzle);
export default __webpack_public_path__ + "static/media/puzzle.7ea98de273c32683e825e06cdba17148.svg";
export { ForwardRef as ReactComponent };